module.exports = __webpack_public_path__ + "tm.svg?7da84c33cbe68b34cb6966e3bdab83e8";